<div class="common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header">
      {{organizationModal.title}}
    </span>
  </div>
  @if (organizationModal.type === 'edit'
    && skin !== 'uk-steel-blue'
    && organizationModal.filialsData?.children.length) {
    <div [ngClass]="{
        'common-section-title__ve-container-white': !organizationModal.seeHolding,
        'common-section-title__ve-container-grey': organizationModal.seeHolding
      }">
      <div class="common-section-title__ve-container-inner--end">
        <button
          (click)="seeStructurHolding()"
          class="common-button__text-noborder">
          <i class="common-icon__md"
            [ngClass]="{
              'lf-icon-arrow-back': organizationModal.seeHolding,
              'lf-icon-process': !organizationModal.seeHolding
            }">
          </i>
          <span class="common-button__text-title"
            [afTranslate]="organizationModal.seeHolding ? 'new-client.exit-structure-holding' : 'new-client.structure-holding'">
            _Salir de extructura del holding || Ver estructura del holding
          </span>
        </button>
      </div>
    </div>
  }
  @if (organizationModal.seeHolding) {
    <organization-chart
      [client]="organizationModal.client"
      [filials]="organizationModal.filialsData"
      (goBack)="seeStructurHolding()">
    </organization-chart>
  }@else {
    <form
      class="common-modal__content-scroll common-organization-modal__form"
      autocomplete="off">
      <div class="common-container__mandatory-obligatory-message-form common-organization-modal__form-item--full">
        <span class="common-tag__mandatory-text-asterisk">
          *
        </span>
        <span
          [afTranslate]="'common.required-fields'"
          class="common-tag__mandatory-label-text-obligatory-message">
          _Campos obligatorios
        </span>
      </div>
      @if (skin !== 'uk-steel-blue') {
        <field-type-switch
          class="common-organization-modal__form-item--full"
          [field]="{label: 'new-client.register-as-a-affiliated-company' | afTranslate}"
          [preSelectItem]="organizationModal.businessGroup"
          [small]="true"
          [disabled]="(!organizationModal.createFilials || organizationModal.disabledField) || (organizationModal.type ==='edit' && organizationModal.onlyAffiliated)"
          (itemSelected)="checkAffiliated()">
        </field-type-switch>
      }
      @if (organizationModal.businessGroup) {
        <field-type-list-simple
          class="common-organization-modal__form-item--half"
          [field]="organizationModal.clientParentId"
          [preSelectItem]="organizationModal.client.parentId"
          [listValues]="organizationModal.clientListModify"
          (itemSelected)="itemSelected('parentId', $event.newValue)">
        </field-type-list-simple>
        <field-type-number
          class="common-organization-modal__form-item--half"
          [field]="organizationModal.clientPercent"
          [decimals]="2"
          [preSelectItem]="organizationModal.client.percentage"
          (itemSelected)="itemSelected('percentage', $event.newValue)">
        </field-type-number>
      }
      @if (skin != 'uk-steel-blue') {
        <field-type-logo
          class="common-organization-modal__form-item--full"
          [field]="organizationModal.clientLogo"
          [type]="organizationModal.type"
          [preSelectItem]="organizationModal.logos"
          [logoInfo]="organizationModal.logoInfo"
          (itemSelected)="itemSelected('logo', $event.newValue)"
          [from]="'organization-modal'">
        </field-type-logo>
      }
      <field-type-text-simple
        [ngClass]="{
          'common-organization-modal__form-item--two-thirds': skin != 'uk-steel-blue',
          'common-organization-modal__form-item--one-third': skin === 'uk-steel-blue',
        }"
        [field]="organizationModal.clientName"
        [preSelectItem]="organizationModal.client.name"
        (itemSelected)="itemSelected('name', $event.newValue)">
      </field-type-text-simple>
      @if (skin === 'uk-steel-blue') {
        <field-type-text-simple
          class="common-organization-modal__form-item--one-third"
          [field]="organizationModal.clientReference2"
          [preSelectItem]="organizationModal.client.reference2"
          (itemSelected)="itemSelected('reference2', $event.newValue)">
        </field-type-text-simple>
        @if (organizationModal.clientTypeId) {
          <field-type-list-simple
            class="common-organization-modal__form-item--one-third"
            [field]="organizationModal.clientTypeId"
            [preSelectItem]="organizationModal.client.clientTypeId"
            [listValues]="organizationModal.clientTypes"
            (itemSelected)="itemSelected('clientTypeId', $event.newValue)">
          </field-type-list-simple>
        }
      }
      <field-type-text-simple
        class="common-organization-modal__form-item--one-third"
        [field]="organizationModal.clientCif"
        [preSelectItem]="organizationModal.client.cif"
        (itemSelected)="itemSelected('cif', $event.newValue)">
      </field-type-text-simple>
      @if (skin === 'uk-steel-blue') {
        <field-type-text-simple
          class="common-organization-modal__form-item--one-third"
          [field]="organizationModal.clientNiNumber"
          [preSelectItem]="organizationModal.client.nI_Number"
          (itemSelected)="itemSelected('nI_Number', $event.newValue)">
        </field-type-text-simple>
        <field-type-text-simple
          class="common-organization-modal__form-item--one-third"
          [field]="organizationModal.clientVatNumber"
          [preSelectItem]="organizationModal.client.vaT_Number"
          (itemSelected)="itemSelected('vaT_Number', $event.newValue)">
        </field-type-text-simple>
      }
      <field-type-text-simple
        class="common-organization-modal__form-item--two-thirds"
        [field]="organizationModal.clientAddress"
        [preSelectItem]="organizationModal.client.address"
        (itemSelected)="itemSelected('address', $event.newValue)">
      </field-type-text-simple>
      @if (skin === 'uk-steel-blue') {
        <field-type-text-simple
          class="common-organization-modal__form-item--one-third"
          [field]="organizationModal.clientCompanyNumber"
          [preSelectItem]="organizationModal.client.company_Number"
          (itemSelected)="itemSelected('company_Number', $event.newValue)">
        </field-type-text-simple>
      }
      @else {
        <field-type-text-simple
          class="common-organization-modal__form-item--one-third"
          [field]="organizationModal.clientPostalCode"
          [preSelectItem]="organizationModal.client.postalCode"
          (itemSelected)="itemSelected('postalCode', $event.newValue)">
        </field-type-text-simple>
      }
      <field-type-text-simple
        class="common-organization-modal__form-item--one-third"
        [field]="organizationModal.clientCity"
        [preSelectItem]="organizationModal.client.city"
        (itemSelected)="itemSelected('city', $event.newValue)">
      </field-type-text-simple>
      @if (skin === 'uk-steel-blue') {
        <field-type-text-simple
          class="common-organization-modal__form-item--one-third"
          [field]="organizationModal.clientPostalCode"
          [preSelectItem]="organizationModal.client.postalCode"
          (itemSelected)="itemSelected('postalCode', $event.newValue)">
        </field-type-text-simple>
      }
      @else {
        <field-type-text-simple
          class="common-organization-modal__form-item--one-third"
          [field]="organizationModal.clientProvince"
          [preSelectItem]="organizationModal.client.province"
          (itemSelected)="itemSelected('province', $event.newValue)">
        </field-type-text-simple>
      }
      <field-type-text-simple
        class="common-organization-modal__form-item--one-third"
        [field]="organizationModal.clientCountry"
        [preSelectItem]="organizationModal.client.country"
        (itemSelected)="itemSelected('country', $event.newValue)">
      </field-type-text-simple>
      <field-type-email
        class="common-organization-modal__form-item--two-thirds"
        [field]="organizationModal.clientEmail"
        [preSelectItem]="organizationModal.client.email"
        (itemSelected)="itemSelected('email', $event.newValue)">
      </field-type-email>
      <field-type-text-simple
        class="common-organization-modal__form-item--one-third"
        [field]="organizationModal.clientPhoneNumber"
        [preSelectItem]="organizationModal.client.phoneNumber"
        (itemSelected)="itemSelected('phoneNumber', $event.newValue)">
      </field-type-text-simple>
      @if (skin === 'uk-steel-blue') {
        <field-type-email
          class="common-organization-modal__form-item--two-thirds"
          [field]="organizationModal.clientEmail2"
          [preSelectItem]="organizationModal.client.email2"
          (itemSelected)="itemSelected('email2', $event.newValue)">
        </field-type-email>
        <field-type-text-simple
          class="common-organization-modal__form-item--one-third"
          [field]="organizationModal.clientPhoneNumber2"
          [preSelectItem]="organizationModal.client.phoneNumber2"
          (itemSelected)="itemSelected('phoneNumber2', $event.newValue)">
        </field-type-text-simple>
        <field-type-text-simple
          class="common-organization-modal__form-item--one-third"
          [field]="organizationModal.clientContactName1"
          [preSelectItem]="organizationModal.client.contactName1"
          (itemSelected)="itemSelected('contactName1', $event.newValue)">
        </field-type-text-simple>
        <field-type-text-simple
          class="common-organization-modal__form-item--one-third"
          [field]="organizationModal.clientContactName2"
          [preSelectItem]="organizationModal.client.contactName2"
          (itemSelected)="itemSelected('contactName2', $event.newValue)">
        </field-type-text-simple>
        <field-type-text-simple
          class="common-organization-modal__form-item--one-third"
          [field]="organizationModal.clientContactName3"
          [preSelectItem]="organizationModal.client.contactName3"
          (itemSelected)="itemSelected('contactName3', $event.newValue)">
        </field-type-text-simple>
      }
      @else {
        <field-type-text-multiline
          class="common-organization-modal__form-item--full"
          [field]="organizationModal.clientObservations"
          [preSelectItem]="organizationModal.client.observations"
          (itemSelected)="itemSelected('observations', $event.newValue)">
        </field-type-text-multiline>
      }
    </form>
    @if (!(organizationModal.type === 'edit' && !organizationModal.organization.canAdmin)) {
      <div class="common-modal__footer">
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title"
            [afTranslate]="'common.cancel'">
            _Cancelar
          </span>
        </button>
        <button class="common-button__text"
          (click)="createOrSaveClient()">
          <span class="common-button__text-title"
            [afTranslate]="organizationModal.type === 'new'?'common.create':'common.save'">
            _Crear/Guardar
          </span>
        </button>
      </div>
    }
  }
</div>
